import React from 'react'

const NewLogoIcon = (
  <>
    <path
      d="M19.4618 8.18119C19.4618 13.9638 14.8184 23.9322 14.4542 23.9322C14.0901 23.9322 7.89893 14.7832 7.89893 9.00059C7.89893 3.21809 10.4765 0.62439 13.5438 0.62439C16.6111 0.62439 19.4618 2.39859 19.4618 8.18119Z"
      fill="url(#paint0_linear_2428_3440)"
    />
    <path
      d="M9.91589 11.3913C12.8135 15.034 14.7447 23.7506 14.5044 23.9417C14.2641 24.1328 5.59469 21.6189 2.69719 17.9762C-0.200405 14.3335 0.200694 11.3468 2.22459 9.7369C4.24839 8.1271 7.01839 7.7486 9.91589 11.3913Z"
      fill="url(#paint1_linear_2428_3440)"
    />
    <path
      d="M25.2205 13.5304C25.2205 13.5304 25.1551 16.4692 23.3022 18.3222C21.4492 20.1751 18.5104 20.2405 18.5104 20.2405C18.5104 20.2405 18.5758 17.3017 20.4288 15.4488C22.2817 13.5958 25.2205 13.5304 25.2205 13.5304Z"
      fill="url(#paint2_linear_2428_3440)"
    />
    <path
      d="M7.89639 9.35388C7.89639 9.35388 10.2043 10.5233 12.4806 16.0417C14.1361 19.76 14.5464 23.8286 14.5464 23.8286C14.5464 23.8286 11.9256 20.7442 10.27 17.0259C7.78459 11.7303 7.89639 9.35388 7.89639 9.35388Z"
      fill="#F7007C"
    />
    <defs>
      <linearGradient
        id="paint0_linear_2428_3440"
        x1="4.87333"
        y1="22.837"
        x2="22.1367"
        y2="12.7276"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF00A5" />
        <stop offset="1" stopColor="#FFC100" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2428_3440"
        x1="4.95259"
        y1="22.0203"
        x2="17.0511"
        y2="10.706"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF00A5" />
        <stop offset="1" stopColor="#FFC100" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_2428_3440"
        x1="18.2882"
        y1="21.0541"
        x2="19.5634"
        y2="11.708"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FF00A5" />
        <stop offset="1" stopColor="#FFC100" />
      </linearGradient>
    </defs>
  </>
)

export default NewLogoIcon
